// extracted by mini-css-extract-plugin
export var confirmation = "request-form-module--confirmation--oCTDL";
export var errorSpan = "request-form-module--errorSpan--CVhv7";
export var formHeader = "request-form-module--formHeader--PyqiZ";
export var requestForm = "request-form-module--requestForm--5KCFa";
export var selected = "request-form-module--selected--GwoSM";
export var shippingDetails = "request-form-module--shippingDetails--hZjYm";
export var unselected = "request-form-module--unselected--BbEUk";